import type { ReactNode } from 'react';

import { realtimeFormOptions } from '@/entities/(notification)/realtime';
import { withForm } from '@/shared/ui/form';

import { RealtimeFormPanel } from './realtime-form-panel';

export const RealtimeFormContent = withForm({
  ...realtimeFormOptions,
  props: {
    workspaceId: '',
    renderFooter: undefined as (() => ReactNode) | undefined,
  },
  render: function RealtimeFormContent({ form, workspaceId, renderFooter }) {
    return (
      <div className="px-4 pb-6">
        <RealtimeFormPanel
          form={form}
          workspaceId={workspaceId}
          renderFooter={renderFooter}
        />
      </div>
    );
  },
});
